import React from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickComponentCommonProps } from '../../interfaces/commonProps';
import { useLocale } from '../LocaleProvider';
import { StyledStaticLabel, StyledAnimatedLabel, StyledOptionalText, } from './FormLabel.styles';
import { formLabelPropTypes } from './FormLabel.types';
export const FormLabel = ({ as, children, disabled = false, effect = 'none', empty = false, invalid = false, htmlFor, required = false, ...restProps }) => {
    let StyledLabel;
    switch (effect) {
        case 'scale':
        case 'float':
            StyledLabel = StyledAnimatedLabel;
            break;
        case 'none':
        default:
            StyledLabel = StyledStaticLabel;
    }
    const locale = useLocale();
    return (React.createElement(StyledLabel, { as: as, "data-testid": `testid_${htmlFor}`, disabled: disabled, effect: effect, empty: empty, invalid: invalid, htmlFor: htmlFor, outerSpacing: useSpacing(restProps), required: required, ...pickComponentCommonProps(restProps) },
        children,
        ' ',
        !required && (React.createElement(StyledOptionalText, null, locale.formLabel.optional))));
};
FormLabel.propTypes = formLabelPropTypes;
//# sourceMappingURL=FormLabel.js.map